// slideshow.js
import { each, selectAll } from './utils/dom';
import { recaptchaKeys } from './constants';

// select login buttons
const submitButtons = selectAll('.btn-login');
let loginForm = '';

// callback function for reCAPTCHA
function loginSubmit() {
  loginForm.submit();
}
// make it available globally
window.loginSubmit = loginSubmit;

window.addEventListener('load', () => {
  // handle button clicks to prevent form submission until reCAPTCHA executes
  each(submitButtons, (button) => {
    // get the form ID from the data-form attribute on the submit button
    const formId = button.dataset.form;
    loginForm = document.querySelector(`#${formId}`);
    const recaptchaContainer = document.querySelector('.g-recaptcha');
    // explicit callback function on load for dynamic sitekey
    function recaptchaLoaded() {
      grecaptcha.render(recaptchaContainer, { // eslint-disable-line no-undef
        sitekey: recaptchaKeys,
        callback: loginSubmit,
        badge: 'bottomright',
        size: 'invisible',
      });
    }
    window.recaptchaLoaded = recaptchaLoaded;
    button.addEventListener('click', (e) => {
      // execute reCAPTCHA
      grecaptcha.execute(); // eslint-disable-line no-undef
      e.preventDefault();
    });
  });

  // only load the reCAPTCHA script if it's not already loaded by
  // our Vue-specific component
  if (!window.grecaptcha && submitButtons.length > 0) {
    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit');
    document.getElementsByTagName('head')[0].appendChild(script);
  }
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/recaptcha.js